// src/pages/admin/LecteurEvaluationDemo.jsx
import React, { useState, useEffect } from 'react';
import { APP_CONFIG } from '../../../config/appConfig';
import Evaluation from '../../../components/communs/Evaluation';
import { Loader2, AlertCircle } from 'lucide-react';

export default function LecteurEvaluationDemo({
    evaluationId,
    token,
    onClose,
    initialEvaluation,
}) {
    const [loading, setLoading] = useState(!initialEvaluation);
    const [error, setError] = useState(null);
    const [evaluation, setEvaluation] = useState(initialEvaluation || null);

    useEffect(() => {
        if (evaluation) return;
        const fetchEvaluation = async () => {
            try {
                const response = await fetch(
                    `${APP_CONFIG.BASE_URL}/api/v1/admin/evaluations/${evaluationId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Accept': 'application/json'
                        }
                    }
                );
                if (!response.ok) throw new Error(`Erreur HTTP ${response.status}`);
                const data = await response.json();
				console.log('📖 [LecteurEvaluationDemo] Données brutes :', data);
				// Vérifier une question APPARIE
				const apparie = (data.questions || []).find(q => q.typeQuestion === 'APPARIE');
				if (apparie) {
				  console.log('🔍 Question APPARIE trouvée :', apparie);
				  console.log('   solutions:', apparie.solutions);
				}
                setEvaluation(data);
            } catch (err) {
                console.error('[LecteurEvaluationDemo] Erreur:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        if (evaluationId && token) fetchEvaluation();
        else if (!evaluationId && !initialEvaluation) {
            setError("Aucun ID d'évaluation fourni");
            setLoading(false);
        }
    }, [evaluationId, token, initialEvaluation, evaluation]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center max-w-md px-4">
                    <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
                    <p className="text-sm text-gray-600">{error}</p>
                    <button onClick={onClose} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg">Fermer</button>
                </div>
            </div>
        );
    }

    if (!evaluation) return null;

    return (
        <Evaluation
            module={{ id: evaluation.id }}
            evaluationData={[{ titre: evaluation.titre, questions: evaluation.questions || [] }]}
            formationTitre={evaluation.titre || 'Évaluation'}
            moduleOrdre={1}
            totalModules={1}
            onClose={onClose}
            isOpen={true}
            onComplete={() => {}}
            onSubmit={() => {}}
            evalType={evaluation.type || 'SOMMATIVE'}
            mode="demo"
            token={token}
        />
    );
}